// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collections-page[data-v-6e6d8ca1]{padding:3rem 0 7rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
